import { Link } from "react-router-dom";
import Button from "../components/Button";
import Typography from "../components/Typography";
import { appPaths } from "../Routes";

const NotFoundPage = () => {
    return (
        <div className="w-full min-h-screen flex flex-col items-center justify-center px-4 bg-surface-light">
            <Typography variant="display-large" component="h1" className="mb-4">
                404
            </Typography>
            <Typography variant="body-medium" component="p" className="mb-4">
                Page not found
            </Typography>
            <Link to={appPaths.home}>
                <Button>Home</Button>
            </Link>
        </div>
    );
};

export default NotFoundPage;
